import { useCrawlerCostContext } from "pages/crawler/providers/CrawlerCostProvider";
import { LegacyRateCallout } from "components/LegacyRateCallout";

interface CrawlerCostCalculatorProps {
  /** Page-load state — hide the badge while the form is still loading. */
  isLoading?: boolean;
}

const CrawlerCostCalculator = ({ isLoading = false }: CrawlerCostCalculatorProps) => {
  const { costPerRequest, costLoading, legacyStandardCredits } = useCrawlerCostContext();

  if (isLoading) {
    return null;
  }

  return (
    <div className="flex flex-row flex-wrap items-center gap-2 mt-2">
      <div className="bg-info-100 text-xs px-2 py-1 rounded inline-block">
        Est. cost per URL: {costLoading ? 'Calculating...' : `${costPerRequest} credits`}
      </div>
      {!costLoading && <LegacyRateCallout standardCredits={legacyStandardCredits} variant="inline" />}
    </div>
  );
};

export default CrawlerCostCalculator;
